export default __webpack_public_path__ + "static/activities_image_one_mobile-c4f014be49b22dd0493e3ebd4daca50d.jpg";